import { useContext } from 'react';
import {
    TasksAndAlertsAnalyticsContext,
    TasksAndAlertsAnalyticsContextData
} from './context';

export function useTasksAndAlertsAnalytics(): TasksAndAlertsAnalyticsContextData {
    const data = useContext<TasksAndAlertsAnalyticsContextData | undefined>(
        TasksAndAlertsAnalyticsContext
    );

    if (!data) {
        throw new Error(
            "TasksAndAlertsAnalyticsContext unavailable. Are you sure you're using this in a nested component of an TasksAndAlertsAnalyticsProvider?"
        );
    }

    return data;
}
